<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-view-complete-log :callCheckRequest="callCheckRequest"/>

    <section>
      <page-header :headerName="'Logs (App , MarQTab e MarQWeb)'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-group input-with-date">
                      <label>Data Inicial</label>
                      <datepicker ref="programaticOpen3" v-model="dataSearch.init" :language="ptBR"
                                  :format="customFormatter"/>
                      <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-group input-with-date">
                      <label>Data Final</label>
                      <datepicker ref="programaticOpen4" v-model="dataSearch.end" :language="ptBR"
                                  :format="customFormatter"/>
                      <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="companyId">ID da empresa</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="companyId"
                             name="companyId" placeholder="ID da empresa"/>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>UserId</label>
                      <input v-model="dataSearch.userId" type="text" class="form-control" name="userId"
                             placeholder="UserID" required/>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>eLogPointType </label>
                      <select v-model="dataSearch.eLogPointType">
                        <option value="">Todos</option>
                        <option value="1">App</option>
                        <option value="2">MarQTab</option>
                        <option value="3">MarQWeb</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="
                !loadingList &&
                dataLog !== '' &&
                !dataLog.length &&
                !failRequest
              " class="col-xs-12 col-sm-12 col-md-12">
              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  content-default
                ">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  content-default
                ">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataLog.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span class="caption-subject font-blue bold uppercase">
                      Quantidade total de logs ({{ dataLog.length }})
                    </span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th>EMPRESA</th>
                        <th>FUNCIONÁRIO</th>
                        <th>DATA DE ENVIO</th>
                        <th>APLICAÇÃO</th>
                        <th>PLATAFORMA</th>
                        <th>VERSÃO</th>
                        <th>AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataLog">
                        <td>
                          <p v-if="!c.contentString">{{ c.companyName }}</p>
                          <a v-if="c.contentString" v-bind:href="
                                '/detalhes-da-empresa/' +
                                c.companyId +
                                '/' +
                                c.contentString
                              " target="_blank" class="link">{{ c.companyName }}</a>
                        </td>
                        <td>{{ c.userName }}</td>
                        <td>{{ c.createdAt }}</td>
                        <td>{{ c.logPointTypeStr }}</td>
                        <td>{{ c.platformDeviceStr }}</td>
                        <td>{{ c.soVersion }}</td>
                        <td>
                          <a v-on:click="openDetail(c)" target="_blank" title="Visualizar" class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                            Visualizar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import swal from "sweetalert";
import moment from "moment";

import {
  GET_STORED_LOG
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import ModalViewCompleteLog from "../../modals/modalViewCompleteLog";
import {ALERT_SERVICE} from "../../../../msgAlertService";

export default {
  name: "log-stored",
  components: {
    ModalViewCompleteLog,
    datepicker,
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      callCheckRequest: "",
      ptBR: ptBR,
      failRequest: false,
      loadingList: false,
      dataLog: "",
      dataSearch: {
        init: new Date(moment().subtract(30, "days")),
        end: new Date(moment().subtract(0, "days")),
        companyId: "",
        userId: "",
        eLogPointType: "",
      },
    };
  },
  methods: {
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getList() {
      if (this.dataSearch.init && this.dataSearch.end) {
        moment.locale("pt-br");

        this.loadingList = true;
        let url = GET_STORED_LOG;
        url += "?init=" + moment(this.dataSearch.init).format("MM-DD-YYYY");
        url += "&end=" + moment(this.dataSearch.end).format("MM-DD-YYYY");

        if (this.dataSearch.companyId)
          url += "&companyId=" + this.dataSearch.companyId;

        if (this.dataSearch.userId) url += "&userId=" + this.dataSearch.userId;

        if (this.dataSearch.eLogPointType)
          url += "&eLogPointType=" + this.dataSearch.eLogPointType;

        // api/v1/info/GetPointLogReport?init=30-08-2020&end=10-08-2020&companyId=691684062F204A17A2C20D40B88E101B&userId=FE79E4E9AC65465B8BB8A4F0EEA30538
        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.requestContext("GET", url, this.dataSearch.header)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GET_STORED_LOG:", response.data);

            if (response.data.items.length) this.dataLog = response.data.items;
            else this.dataLog = [];

            this.loadingList = false;
            this.failRequest = false;
          })
          .catch((reason) => {
            this.loadingList = false;
            this.failRequest = true;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal("Aviso", "´Preencha as datas para pesquisar", "error");
      }
    },
    openDetail(data) {
      this.callCheckRequest = {
        random: Math.floor(Math.random() * 500),
        id: data.id,
        contentString: data.contentString,
      };

      $("#modalViewCompleteLog").modal();
    },
  },
};
</script>

<style lang="scss">
.input-with-date {
  width: 100%;

  input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/logPoint/logStored.vue